import { useState } from "react";

import styled from "styled-components/macro";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import { marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import { copyToClipboard } from "Utilities/copyToClipboard";
import { defaultShadow } from "Utilities/interpolations/shadow";

const NetworkIDPill = () => {
  const [{ networkID }] = useNetworkMetadata();
  const [copied, setCopied] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent navbar section collapse
    copyToClipboard(networkID);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Wrapper
      data-cy="NavBar_TopArea_NetworkID"
      onClick={handleClick}
      title="Click to copy"
    >
      {copied ? "Copied!" : `ID: ${networkID}`}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  padding: 0 6px;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
  color: white;
  background-color: ${addOpacity("#000000", 0.5)};
  border-radius: 9999px;
  border: 1px solid ${addOpacity(marketingColors.gray, 0.15)};
  cursor: pointer;
  transition: background-color 0.15s ease;
  ${defaultShadow}

  &:hover {
    background-color: ${addOpacity("#000000", 0.7)};
  }
`;

export default NetworkIDPill;
